import {booleanAttribute, ChangeDetectionStrategy, Component, computed, Injectable, input, model} from "@angular/core";
import {AvstemningsstatusModell, MøtedeltakereModell, MøtedeltakerId, MøtedeltakerModell, MøteId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {InlineMeldingKomponent} from "web-ng2/delt/komponenter/inline-melding/inline-melding";
import {TranslateModule} from "@ngx-translate/core";
import {TipsKomponent} from "web-ng2/delt/komponenter/tips/tips";
import {MatButtonModule} from "@angular/material/button";
import {Møtedialoger} from "../../../møte/tjenester/Møtedialoger";
import {Steg} from "../../../møte/modale/møte-rediger-dialog/møte-rediger-dialog";
import {MøteModellDLM} from "felles-ng2/tjenester/datalager/MøteDatatjeneste";
import {stemmevektAvvikerFraAntallAksjer} from "felles-ng2/modell/møtedeltakerModellHjelpere";
import {AvstemningVisStemmeberettigedeKomponent} from "web-ng2/moduler/avstemning/komponenter/avstemning-vis-stemmeberettigede/avstemning-vis-stemmeberettigede";
import {AvstemningRedigerStemmeberettigedeKomponent} from "web-ng2/moduler/avstemning/komponenter/avstemning-rediger-stemmeberettigede/avstemning-rediger-stemmeberettigede";
import {AvstemningDatatjeneste} from "felles-ng2/tjenester/datalager/AvstemningDatatjeneste";
import {i18n} from "felles-ng2/tjenester/i18n/Oversettelser";
import {MeldingTilBrukerNg2} from "felles-ng2/tjenester/MeldingTilBrukerNg2";

const debug = initDebugger('AvstemningStemmeberettigedeKomponent');

/**
 * Viser oversikt over stemmeberettigede ifbm avstemninger.
 * Med mulighet for å redigere stemmeberettigelse og stemmevekt.
 */
@Component({
    selector: 'avstemning-stemmeberettigede',
    templateUrl: 'avstemning-stemmeberettigede.html',
    styleUrl: 'avstemning-stemmeberettigede.scss',
    imports: [
        InlineMeldingKomponent,
        TranslateModule,
        TipsKomponent,
        AvstemningVisStemmeberettigedeKomponent,
        AvstemningRedigerStemmeberettigedeKomponent,
        MatButtonModule
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvstemningStemmeberettigedeKomponent {

    moete = input.required<MøteModellDLM>();
    moetedeltakere = input.required<MøtedeltakerModell[]>();
    avstemningsstatus = input.required<AvstemningsstatusModell>();
    brukerKanRedigere = input(false, {transform: booleanAttribute});

    //visStemmeberettigedeDeltakere = model(false);
    erRedigermodus = model(false);
    stemmeberettigede = computed(() => this.moetedeltakere().filter(d => d.erStemmeberettiget));
    visAntallAksjer = computed(() => this.moetedeltakere().some(d => d.aksjeeierRepresentasjoner.length > 0));
    stemmevektAvvikerFraAntallAksjer = computed(() => this.visAntallAksjer() ? stemmevektAvvikerFraAntallAksjer(this.stemmeberettigede()) : false);

    constructor(private avhengigheter: AvstemningStemmeberettigedeKomponentAvhengigheter,
                private møtedialoger: Møtedialoger,
                private meldingTilBruker: MeldingTilBrukerNg2) {
    }

    redigerMoetedeltakere() {
        this.møtedialoger.visRediger(this.moete().id, Steg.deltakere);
    }

    rediger() {
        this.erRedigermodus.set(true);
    }

    async nullstillAvgitteStemmer(deltaker: MøtedeltakerModell) {
        await this.avhengigheter.nullstillAvgitteStemmer(this.moete().id, deltaker.id);
        this.meldingTilBruker.infomelding(i18n('Deltakers stemmegivning har blitt nullstilt'));
    }

    vedRedigerLukket(oppdaterteDeltakere: MøtedeltakereModell | null) {
        this.erRedigermodus.set(false);
    }
}

@Injectable()
export class AvstemningStemmeberettigedeKomponentAvhengigheter {

    constructor(private avstemningDatatjeneste: AvstemningDatatjeneste) {
    }

    async nullstillAvgitteStemmer(møteId: MøteId, deltakerId: MøtedeltakerId): Promise<void> {
        await this.avstemningDatatjeneste.nullstillAvgitteStemmerForDeltaker(møteId, deltakerId);
    }

}
